export default class WebAuthnError extends Error {
  code: WebAuthnErrorCode;

  constructor({
    message,
    code,
    cause,
    name,
  }: {
    message: string;
    code: WebAuthnErrorCode;
    cause: Error;
    name?: string;
  }) {
    super(message);
    this.name = (
      name !== undefined ? name : cause ? cause.name : undefined
    ) as string;
    this.code = code;
  }
}

export type WebAuthnErrorCode =
  | "ERROR_CEREMONY_ABORTED"
  | "ERROR_INVALID_DOMAIN"
  | "ERROR_INVALID_RP_ID"
  | "ERROR_INVALID_USER_ID_LENGTH"
  | "ERROR_MALFORMED_PUBKEYCREDPARAMS"
  | "ERROR_AUTHENTICATOR_GENERAL_ERROR"
  | "ERROR_AUTHENTICATOR_MISSING_DISCOVERABLE_CREDENTIAL_SUPPORT"
  | "ERROR_AUTHENTICATOR_MISSING_USER_VERIFICATION_SUPPORT"
  | "ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED"
  | "ERROR_AUTHENTICATOR_NO_SUPPORTED_PUBKEYCREDPARAMS_ALG"
  | "ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY";
